import React from 'react';
import { TiArrowForward } from "react-icons/ti";
import './StoreList.css';

const StoreList = ({ stores, onStoreSelect }) => {
  return (
    <div className="store-list">
      {stores.map(store => (
        <div 
          key={store.id} 
          className="store-card"
          onClick={() => onStoreSelect(store)}
        >
          
          <img src={store.image} alt={store.name} className="store-image" />
          <div className="store-info">
            <h3>{store.name}</h3>
            <p className="store-address">{store.address}</p>
            <div className="store-hours">
              {store.hours.split('\n').map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          </div>
          <div className="store-arrow"><TiArrowForward /></div>
        </div>
      ))}
    </div>
  );
};

export default StoreList;